import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component MarkerIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <MarkerIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <MarkerIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const MarkerIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="MarkerIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        d="M12 17a1 1 0 010 2H4a1 1 0 010-2h8zm0-4a1 1 0 010 2H4a1 1 0 010-2h8zm10-1a1 1 0 01-.883.993l-5.25-.002c-.214 0-.442-.06-.626-.2L13.436 11H4a1 1 0 010-2h9.592l1.611-1.604A.998.998 0 0116 7h5a1 1 0 011 1v4zm-5.579-3.001l-1.079 1.079.921.921 3.736.001V9l-3.578-.001zM12 5a1 1 0 010 2H4a1 1 0 110-2h8z"
        fillRule="evenodd"
      />
    </svg>
  )
);
MarkerIcon.displayName = "MarkerIcon";
export default MarkerIcon;
